import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { Box, TextField, Button, Grid, Typography, Container } from "@mui/material";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

export default function Contact(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(
      `Name: ${name}, Email: ${email}, Message: ${message}, Phone: ${phone}`
    );
    
    emailjs
      .send(
        "shilpaa",
        "crm_template",
        {
          name,
          email,
          phone,
          message,
        },
        {
          publicKey: process.env.REACT_APP_EMAIL_JS_API_KEY,
        }
      )
      .then(() => {
        console.log("Email sent successfully");
        setName("");
        setEmail("");
        setMessage("");
        setPhone("");
      })
      .catch((error) => {
        console.error("Error sending email:", error);
      });
  };

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Grid container spacing={4}>
        {/* Left Column - Contact Information */}
        <Grid item xs={12} md={5}>
          <Box sx={{ mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom sx={{ color: "#BF0A30", fontWeight: "bold" }}>
              Contact Us
            </Typography>
            <Typography variant="body1" paragraph>
              We'd love to hear from you. Please feel free to reach out to us using any of the following methods.
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <LocationOnIcon sx={{ color: "#BF0A30", fontSize: 28 }} />
              <Box>
                <Typography variant="h6" gutterBottom>Our Location</Typography>
                <Typography variant="body1">
                  123 Business Street<br />
                  Hyderabad, Telangana 500001<br />
                  India
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <PhoneIcon sx={{ color: "#BF0A30", fontSize: 28 }} />
              <Box>
                <Typography variant="h6" gutterBottom>Phone Number</Typography>
                <Typography variant="body1">
                  +91 123 456 7890<br />
                  +91 987 654 3210
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <EmailIcon sx={{ color: "#BF0A30", fontSize: 28 }} />
              <Box>
                <Typography variant="h6" gutterBottom>Email Address</Typography>
                <Typography variant="body1">
                  info@shilpaa.com<br />
                  support@shilpaa.com
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Map or Additional Information can be added here */}
          <Box sx={{ mt: 4, height: 300, bgcolor: '#f5f5f5', borderRadius: 2 }}>
            {/* Add your map component here */}
            <Typography variant="body1" sx={{ p: 2, textAlign: 'center' }}>
              Map will be displayed here
            </Typography>
          </Box>
        </Grid>

        {/* Right Column - Contact Form */}
        <Grid item xs={12} md={7}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              p: 4,
              bgcolor: '#fff',
              borderRadius: 2,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#BF0A30" }}>
              Send us a Message
            </Typography>
            <TextField
              label="Name"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label="Email"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label="Phone"
              variant="outlined"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label="Message"
              variant="outlined"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              multiline
              rows={6}
              required
              fullWidth
            />
            <Button
              variant="contained"
              type="submit"
              sx={{
                backgroundColor: "#BF0A30",
                "&:hover": { backgroundColor: "#a30d26" },
                fontSize: "1.1rem",
                py: 1.5,
                mt: 2,
              }}
            >
              Send Message
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
